/* LUMAVA · Carrusel (comportamiento compartido)
 *
 * Gobierna cualquier [data-lv-carousel]. Es idempotente: si dos secciones
 * de la misma pagina cargan este archivo, la segunda pasada no reengancha
 * nada. Tambien se reengancha al recargar una seccion en el editor de
 * temas, que es cuando se van anadiendo bloques.
 */
(function () {
  function init(root) {
    if (root.dataset.lvCarReady) return;

    var track = root.querySelector('[data-lv-car-track]');
    if (!track) return;

    var controls = root.querySelector('[data-lv-car-controls]');
    var prev = root.querySelector('[data-lv-car-prev]');
    var next = root.querySelector('[data-lv-car-next]');
    if (!prev && !next) return;

    root.dataset.lvCarReady = '1';

    function gap() {
      return parseFloat(getComputedStyle(track).columnGap) || 0;
    }

    // Un clic avanza exactamente una tarjeta, hueco incluido.
    function step() {
      var card = track.querySelector('[data-lv-car-card]');
      return card ? card.getBoundingClientRect().width + gap() : track.clientWidth;
    }

    // Si el riel cabe entero no hay nada que deslizar: fuera los botones.
    // Una flecha apagada es peor que ninguna flecha.
    function sync() {
      var deslizable = track.scrollWidth > track.clientWidth + 1;
      if (controls) controls.hidden = !deslizable;
      if (!deslizable) return;

      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // Las fotos pueden cambiar el ancho del riel al terminar de cargar.
    window.addEventListener('load', sync);
    sync();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lv-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
